module.exports = __webpack_public_path__ + "15a98a29b324f2155b3f3ff025670880.jpg";